import {LocalizedDictionary} from '../Translator';

export default {
  "DD": "DD",
  "Discontinued": "Üretimi durduruldu",
  "Spare part list": "Yedek parça listesi",
  "Download Excel": "Excel\u0027i İndirin",
  "Recent search list": "Son arama listesi",
  "No data": "Veri yok",
  "spare part": "YEDEK PARÇA",
  "none": "Hiçbiri",
  "no value": "değer yok",
  "No results found": "Sonuç bulunamadı",
  "Spare parts for": "Yedek parçalar için",
  "Could not load cumulated data": "Kümelenmiş veriler yüklenemedi",
  "commissioning part": "devreye alma bölümü",
  "wear part": "aşınma parçası",
  "Search": "Arama",
  "Tk": "Tk",
  "Spare part number": "Yedek parça numarası",
  "drawing": "çizim",
  "Products for": "Ürünler için",
  "Available": "Mevcut",
  "MM": "MM",
  "The entered order code is invalid": "Girilen sipariş kodu geçersiz",
  "Recommended": "Tavsiye edilir",
  "No data available for the entered search parameters": "Girilen arama parametreleri için veri mevcut değil",
  "Search spare parts": "Yedek parça arama",
  "Order code / product root / serial number": "Sipariş kodu / ürün kökü / seri numarası",
  "Characteristic": "Karakteristik",
  "Please enter an order code": "Lütfen bir sipariş kodu girin",
  "Regarding quality- and security-aspects Endress+Hauser strongly recommends the exclusive use of genuine Endress+Hauser spare parts. The instrument may only be maintained and repaired by qualified personnel. The device documentation, applicable standards and legal requirements as well as any certificates have to be observed!": "Kalite ve güvenlik açısından Endress+Hauser, yalnızca orijinal Endress+Hauser yedek parçalarının kullanılmasını şiddetle tavsiye eder. \nCihazın bakımı ve onarımı sadece kalifiye personel tarafından yapılmalıdır. \nCihaz dokümantasyonu geçerli standartlar ve yasal gerekliliklerin yanı sıra tüm sertifikalar dikkate alınmalıdır!",
  "Maintenance advice": "Bakım tavsiyesi",
  "Mo.": "Mo.",
  "For which product(s) can my spare part be used? Filling in the spare part order code (e.g. 71002865 or XPD0024) shows the relevant devices this spare part can be used in.": "Yedek parçam hangi ürün(ler) için kullanılabilir? Yedek parça sipariş kodunun (örn. 71002865 veya XPD0024) doldurulması, bu yedek parçanın kullanılabileceği ilgili cihazları gösterir.",
  "tool": "araç",
  "Production numbers": "Üretim rakamları",
  "New alternative": "Yeni alternatif",
  "There are no items selected. Please use the checkboxes to make your selection": "Seçili öğe yok. Seçiminizi yapmak için lütfen onay kutularını kullanın",
  "Service segmentation": "Hizmet segmentasyonu",
  "Seg": "Seg",
  "Valid": "Geçerli",
  "Pos": "Pos",
  "Value": "Değer",
  "service segmentation 2": "Temel bilgi gerektiren parçalar. E+H temel eğitimine başarılı bir şekilde katılmak bir ön koşuldur.",
  "Phase out date": "Aşama bitiş tarihi",
  "service segmentation 1": "Temel bilgi gerektiren parçalar.",
  "Which spare parts are available for my product? Filling in the order code (e.g. FTC260-AA2A1 or PMC51-BA21JB1CGBTDJB) or the product id (e.g. FTC260 or 83F50) shows the relevant spare parts.": "Ürünüm için hangi yedek parçalar mevcut? Sipariş kodu (örn. FTC260-AA2A1 veya PMC51-BA21JB1CGBTDJB) veya ürün kimliği (örn. FTC260 veya 83F50) girildiğinde ilgili yedek parçalar gösterilir.",
  "Set filter": "Filtreyi ayarla",
  "Search date": "Arama tarihi",
  "Group": "Grup",
  "Warning": "Uyarı",
  "Description": "Açıklama",
  "Cancel": "İptal",
  "service segmentation 4": "Fabrikada onarım için parçalar. Uzman bilgisi zorunludur.",
  "service segmentation 3": "Özel bilgi gerektiren parçalar. E+H ileri eğitimine başarılı katılım bir ön koşuldur.",
  "Drawing Position Number": "Çizim Pozisyon Numarası",
  "Spare parts search": "Yedek parça arama",
  "Confirm": "Onaylayın",
  "Ordercode too short": "Sipariş kodu çok kısa",
  "Product status": "Ürün durumu",
  "Open": "Açık",
  "Clear": "Temiz",
  "PDF file with assembly instructions": "Montaj talimatlarını içeren PDF dosyası",
  "Search products": "Ürün arama",
  "Export": "İhracat",
  "Production date": "Üretim tarihi",
  "Order stop": "Sipariş durdurma",
  "Calibration until": "Kalibrasyona kadar",
  "PDF file with compatibility information": "Uyumluluk bilgilerini içeren PDF dosyası",
  "Add selection to cart": "Seçimi sepete ekle",
  "Mounting advices": "Montaj önerileri",
  "Recommended parts only": "Yalnızca önerilen parçalar",
  "not applicable": "Geçerli değil",
  "accessories": "aksesuarlar",
  "Cumulative spare parts list": "Kümülatif yedek parça listesi",
  "YYYY": "YYYY",
  "Title": "Başlık",
  "Error": "Hata",
  "Ordercode too long": "Sipariş kodu çok uzun",
  "Functions": "Fonksiyonlar",
  "Rec": "Rec",
  "Type": "Tip",
  "Spare sensor until": "Yedek sensör kadar",
  "Spare parts until": "Yedek parçalar",
  "Filter": "Filtre",
  "Check all": "Hepsini kontrol edin",
  "Order code": "Sipariş kodu",
  "Repair until": "Onarıma kadar",
  "Tag": "Etiket",
  "Ok": "Tamam.",
  "Category code": "Kategori kodu",
  "Phase out": "Aşama dışı",
  'Compatibility advices': 'Ek belgeler',
  'Co.': 'Ek bel.',
} as LocalizedDictionary;
